<template lang="pug">
  div.heightMax
    div.status-cero
      div.status-cero__title(v-if="title") {{ $t(title) }}
      div.status-cero__description(v-if="description") {{ $t(description) }}
</template>

<script>
export default {
  name: 'StatusCero',
  data () {
    return {
    }
  },
  props: {
    title: {
      type: String
    },
    description: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">

.heightMax{
  align-items: center;
  display: flex;
  // display: inline-block;
  height: calc(100% - 50px);
  // margin: 10% auto;
  margin: 0 auto;
  width: 100%;

  .status-cero{
    background-color: $--color-neutral-4;
    margin: 0 auto;
    max-width: rem(220);
    padding: rem(24) rem(40);
    &__title{
      color: $--color--grey-medium;
      font-size: 9px;
      font-weight: 500;
      line-height: rem(16);
      text-transform: uppercase;
    }

    &__description{
      color: $--color-grey-dark;
      font-size: rem(14);
      font-weight: 500;
      letter-spacing: 0.2px;
      line-height: rem(21);
      margin-top: rem(4);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/StatusCero.vue